import React from 'react';
import PropTypes from 'prop-types';
import { Label } from 'reactstrap';
import { MultiSelectFieldArrayWithModal } from 'ui-blocks/form-elements';

const FieldItemWithModal = (props) => {
   return (
      <Label
         className='d-block'
      >
         { props.label }
         <MultiSelectFieldArrayWithModal
            {
               ...props
            }
         />
      </Label>
   );
};

FieldItemWithModal.propTypes = {
   label: PropTypes.string.isRequired,
};

export default FieldItemWithModal;
